import {API} from '../API';

export class LoadService {

  async saveLoad(order, data) {
    let method = 'post';
    let url = `sales-orders/${order.id}/loads`;
    if (data.id) {
      method = 'put';
      url = `${url}/${data.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async deleteLoad(order, load) {
    return (await API.getConnection())
      .delete(`sales-orders/${order.id}/loads/${load.id}`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async reorderLoads(order, loads) {
    return (await API.getConnection())
      .put(`sales-orders/${order.id}/loads`, {loads})
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
